import React from 'react';
import { getSortClass } from 'HelperFunctions/rentals';
import SubrentalsLegend from 'Components/rentals/SubrentalsLegend';
import { SubrentalsAllHeadProps } from './SubrentalsAll.types';

const SubrentalsAllHead: React.FC<SubrentalsAllHeadProps> = ({
  sortField,
  sortDirection,
  onSort,
  multilocationAllLocations,
}) => (
  <tr>
    {multilocationAllLocations && <th className='exSm'>Location</th>}
    <th className='lg'>
      <span
        className={getSortClass('name', sortField, sortDirection)}
        onClick={() => onSort('name')}
      >
        Item
      </span>
    </th>
    <th className='date med'>
      <span
        className={getSortClass('off_shelf_at', sortField, sortDirection)}
        onClick={() => onSort('off_shelf_at')}
      >
        Date
      </span>
    </th>
    <th className='med'>
      <span>Supplier</span>
    </th>
    <th className='med'>
      <span>Contact</span>
    </th>
    <th className='med'>Contact Info</th>
    <th className='med'>Expenses</th>
    <th className='actionSm'>
      <SubrentalsLegend />
    </th>
  </tr>
);

export default SubrentalsAllHead;
